import "./index.styl";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import Axios from "axios";

import "./extensions";
import App from "./App";
import history from "./history";
import env from "./env";
import {unregisterAllServiceWorkers} from "./registerServiceWorker";

Axios.defaults.headers = {
  "Content-Type": "application/json",
};

const baseUrl = env.baseUrl;
const rootElement = document.getElementById("root");

ReactDOM.render(
  <Router basename={baseUrl} history={history}>
    <App />
  </Router>,
  rootElement);

unregisterAllServiceWorkers();